export const NoKeyCardType = 'noKeycard';

export type KeycardType =
  | 'AXESS'
  | 'AXESS_DESTINATION'
  | 'SKIDATA'
  | 'noKeycard';
